import {useTranslation} from 'react-i18next';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {Box, Typography} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import ServicePatternIcon from '@icons/ServicePatternIcon';
import SignupIcon from '@icons/SignupIcon';
import ProfileServiceIcon from '@icons/ProfileServiceIcon';
import BellIcon from '@icons/BellIcon';
import Service from '../services/Service';

export default function LikeQuran() {
	const {t} = useTranslation();
	return (
		<>
			<HeaderWithIcons title={t('i_like_quran')}/>
			<div className="flex flex-col space-y-10 px-4">
				<Box sx={{
					borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.grey[700],
					bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : 'background.paper',
					color: (theme) => theme.palette.mode === 'light' ? 'grey.700' : 'grey.200'
				}} className="border rounded p-4">
					<Typography gutterBottom className="text-base font-bold">{t('i_like_quran_plan')}</Typography>
					<ul className="text-sm font-medium text-justify list-inside list-disc">
						<li>{t('i_like_quran_desc_1')}</li>
						<li>{t('i_like_quran_desc_2')}</li>
						<li>{t('i_like_quran_desc_3')}</li>
						<li>{t('i_like_quran_desc_4')}</li>
					</ul>
					<Typography className="text-sm font-medium text-justify mb-10">{t('i_like_quran_desc')}</Typography>
					<Typography gutterBottom className="text-base font-bold">{t('with')}:</Typography>
					<ul className="text-sm font-medium text-justify list-inside list-disc">
						<li>{t('i_like_quran_with_1')}</li>
						<li>{t('i_like_quran_with_2')}</li>
						<li>{t('i_like_quran_with_3')}</li>
					</ul>
				</Box>
				<Grid container className="w-full">
					<Grid className="relative" sm={4}>
						<Service service={{
							id: 0,
							name: 'signup',
							icon: <ServicePatternIcon><SignupIcon/></ServicePatternIcon>,
							link: 'https://quranlove.quranrazavi.ir/enter/signup'
						}}/>
					</Grid>
					<Grid className="relative" sm={4}>
						<Service service={{
							id: 1,
							name: 'enter',
							icon: <ServicePatternIcon><ProfileServiceIcon/></ServicePatternIcon>,
							link: 'https://quranlove.quranrazavi.ir/enter'
						}}/>
					</Grid>
					<Grid className="relative" sm={4}>
						<Service service={{
							id: 2,
							name: 'notice',
							icon: <ServicePatternIcon><BellIcon/></ServicePatternIcon>,
							link: '/network/25',
							isLocal: true
						}}/>
					</Grid>
				</Grid>
			</div>
		</>
	);
}
